// @flow

import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import Link from 'components/Link';
import __p from 'utils/__p';

const AdBookmarkSignin = (): React.Node => {
    const { __ } = useTranslate();

    return (
        <p className="AdBookmarkSignin">
            {__('ad-bookmark-add-sign-in')}
            <br />
            <Link to={__p('/login')}>
                {__('click-here-to-sign-in')}
            </Link>
        </p>
    );
};

export default AdBookmarkSignin;
